import { useMutation, useQueryClient } from '@tanstack/react-query';
import { archiveDocumentWorkflowTemplate } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useMasterDocumentsEndpoints } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentsEndpoints.ts';

export const useArchiveMasterDocument = (onArchiveSuccess?: () => void) => {
	const tMipManage = useTranslationMipManage();
	const queryClient = useQueryClient();
	const { list: listKey, archive } = useMasterDocumentsEndpoints();

	return useMutation({
		mutationFn: async ({ templateId, archived }: { templateId: string; archived: boolean }) => {
			if (!templateId) {
				throw new Error('Document template ID not found');
			}
			return await archiveDocumentWorkflowTemplate(archive(templateId), { archived });
		},
		onSuccess: async (_, variables) => {
			await queryClient.invalidateQueries({ queryKey: [listKey] });
			onArchiveSuccess?.();
			showToastV2({
				title: tMipManage(
					variables.archived
						? 'master_documents.toast.archive'
						: 'master_documents.toast.unarchive'
				),
			});
		},
	});
};
